import type { ElementType, HTMLAttributes, ReactElement, ReactNode } from 'react';

/**
 * Consistent max-width + horizontal gutter wrapper for marketing page shells.
 * Replaces the ad-hoc `mx-auto max-w-2xl…6xl px-4…6` drift the audit flagged
 * with three named widths. Renders a `<div>` by default; pass `as` to keep a
 * semantic landmark (e.g. `as="header"`, `as="section"`).
 */

export type ContainerWidth = 'prose' | 'default' | 'wide';

const WIDTHS: Record<ContainerWidth, string> = {
  prose: 'max-w-3xl',
  default: 'max-w-5xl',
  wide: 'max-w-6xl',
};

export interface ContainerProps extends HTMLAttributes<HTMLElement> {
  readonly width?: ContainerWidth;
  readonly as?: ElementType;
  readonly className?: string;
  readonly children: ReactNode;
}

export function Container({
  width = 'default',
  as: Tag = 'div',
  className,
  children,
  ...rest
}: ContainerProps): ReactElement {
  return (
    <Tag
      className={['mx-auto w-full px-6', WIDTHS[width], className].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </Tag>
  );
}
